<app-marquee></app-marquee>
<section class="home-wrapper">
    <div class="container">
        <div class="row">


            <!--===== active player and whitepaper ====-->
            <div class="col-12 col-lg-12 mb-4">
                <div class="d-flex align-items-center justify-content-start gap-2 mb-4 mb-md-3">
                    <button class="btn btn-primary activecursor">
                        <svg-icon src="./assets/images/svg-icons/active-player.svg" [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"></svg-icon>
                        <span class="ps-2" translate> active_player </span> {{activeUser}}
                    </button>
                    <a href="/assets/documents/wsmcasino_whitepaper.pdf" target="_blank" alt="" class="wx-200">
                        <button class="btn btn-primary">
                            <svg-icon class="stroke" src="./assets/images/svg-icons/whitepaper.svg"></svg-icon>
                            <span class="ps-2" translate>whitepaper</span>
                        </button>
                    </a>
                </div>
                <div class="col-12 card d-flex flex-column flex-sm-row align-items-center">
                    <div>
                        <svg-icon class="mb-1 mb-sm-0" src="./assets/images/svg-icons/wsm-coin.svg" [svgStyle]="{ 'width.px': 100, 'height.px': 100 }"></svg-icon>
                    </div>
                    <div class="ms-2 d-flex flex-column justify-content-center align-items-center align-items-sm-start">
                        <h2 class="title fw-semibold m-0">WSM</h2>
                        <h1 class="title m-0">CASINO</h1>
                    </div>
                </div>
                <!-- <img src="./assets/images/casino-icon.png" alt=""
                    class="mx-auto img-fluid d-flex justify-content-center  wsmc-logo"> -->
            </div>


            <!--===== wsm value ====-->
            <div class="col-12 col-lg-7 position-relative">
                <div class="card">
                    <div class="d-sm-flex justify-content-center align-items-center flex-wrap gap-2">
                        <div class="d-flex align-items-center">
                            <h3 class="fw-bold m-0">{{'price' | translate}}:</h3>
                            <p class="fw-bold m-0 ps-2 truncate">{{convertNumTwoDec(wsmValues?.price, 5)}} </p>
                        </div>
                        <div class="d-flex align-items-center">
                            <img *ngIf="wsmValues?.priceChangePercentage >= 0" src="./assets/images/svg-icons/up-arrow.svg" alt="" class="up-arrow">
                            <img *ngIf="wsmValues?.priceChangePercentage < 0" src="./assets/images/svg-icons/down-arrow.svg" alt="" class="">
                            <p [class]="'fw-bold ' + (wsmValues?.priceChangePercentage > 0 ? 'text-success' : 'text-danger') + ' m-0 ps-2 truncate'">
                                {{ convertNumTwoDec(wsmValues?.priceChangePercentage) }}%
                            </p>
                        </div>

                        <div class="d-flex align-items-center">
                            <h3 class="fw-bold m-0" translate>volume</h3>
                            <p class="fw-bold m-0 ps-2 truncate">${{convertNumToCurr(wsmValues?.last24hVolume)}}</p>
                        </div>
                        <div class="d-flex align-items-center">
                            <h3 class="fw-bold m-0" translate>tvl</h3>
                            <p class="fw-bold m-0 ps-2 truncate">${{convertNumToCurr(wsmValues?.tvl)}}</p>
                        </div>
                        <div class="d-flex align-items-center">
                            <h3 class="fw-bold m-0" translate>holder</h3>
                            <p class="fw-bold m-0 ps-2 truncate">{{convertNum(wsmValues?.holders)}}</p>
                        </div>
                    </div>
                    <!-- <img src="./assets/images/svg-icons/box-top.svg" alt="" class="top" *ngIf="!isMobile"> -->
                </div>
            </div>


            <!--===== wsm bought button ====-->
            <div class="col-12 col-lg-5 position-relative mt-4 mt-md-0">
                <div class="silver-btn primary-btn d-flex justify-content-between align-items-center px-3">
                    <a href="https://bscscan.com/token/0x62694d43ccb9b64e76e38385d15e325c7712a735"
                        target="_blank" class="fw-bold text-decoration-none text-center text-black w-100">
                        <span class="font-14 text-uppercase"> ${{convertNum(chartOptions?.total_usd_burnt_value)}} {{'burnt_so_far' | translate }}</span>
                        <!-- <span class="font-14" translate>burn_coming_soon</span>! -->
                    </a>
                    <!-- <div class="popover__wrapper mb-0 wx-20">
                        <h2 class="popover__title info-icon m-0">
                            <svg-icon src="./assets/images/svg-icons/info.svg"
                                    [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"></svg-icon>
                        </h2>
                        <div class="popover__content text-start">
                            <p class="popover__message mb-0" translate>boughtback_tooltip</p>
                        </div>
                    </div> -->
                </div>
                <!-- <img src="./assets/images/svg-icons/box-top2.svg" alt="" class="bottom" *ngIf="!isMobile"> -->
            </div>


            <!--===== charts ====-->
            <div class="col-12 col-lg-4 mt-4" *ngFor="let card of revenueData; index as i">
                <div class="card p-0 chart" *ngIf="revenueData">
                    <div class="d-flex justify-content-between align-items-center px-3 pt-0">
                        <div class="semi-title font-14" translate>{{card.title}}</div>
                        <div class="popover__wrapper mb-0">
                            <h2 class="popover__title info-icon m-0">
                                <svg-icon src="./assets/images/svg-icons/info.svg"
                                    [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"></svg-icon>
                                <!-- <img src="./assets/images/svg-icons/info.svg" alt="" height="20"> -->
                            </h2>
                            <div class="popover__content text-start">
                                <p class="popover__message mb-0" translate>{{card.tooltip}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center px-3">
                        <div class="title font-20 text-uppercase">${{convertNum(revenueData[i].revenueUsd)}}</div>
                        <!-- <div class="d-flex">
                            <h3 class="font-14 fw-bold text-success m-0" translate>{{revenueData[i].percent}}%</h3>
                            <img src="./assets/images/svg-icons/money.svg" alt="" class="ps-2">
                        </div> -->
                    </div>
                    <p class="font-10 pt-2 m-0 px-3">{{convertNum(revenueData[i].revenueWsm)}} $WSM</p>

                    <app-revenue-chart [chartIndex]="i" [chartData]="revenueData"></app-revenue-chart>

                </div>
            </div>

            
             <!--===== reward wallet chart  ====-->
             <!-- <div class="col-12 mt-4">
                <div class="card py-2 px-3 flex-column flex-lg-row justify-content-between min-height">
                    <div class="col-12 col-lg-4">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="title font-14 text-uppercase" translate>revenue_burn_tracker</div>
                            <div class="popover__wrapper">
                                <h2 class="popover__title info-icon m-0"> 
                                    <svg-icon src="./assets/images/svg-icons/info.svg"
                                    [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"></svg-icon>
                                </h2>
                                <div class="popover__content text-start">
                                    <p class="popover__message mb-0" translate>revenue_burn_tracker_tooltip</p>
                                </div>
                            </div>
                        </div>
                        <div class="title font-20 text-uppercase">{{convertNum(chartOptions.total_wsm_burnt_value)}} WSM</div>
                        <p class="font-14 pt-1 m-0">${{convertNum(chartOptions.total_usd_burnt_value)}}</p>

                        <div class="count-down-timer">
                            <p class="text-start text-uppercase">Next Burn 🔥</p>
                            <div class="wrapper">
                              <div class="times">
                              <div><p>{{liveCounter._days}}</p><span class="description">Days</span></div><span class="font-28">:</span>
                               <div><p>{{liveCounter._hours}}</p><span class="description">Hours</span></div><span class="font-28">:</span>
                               <div><p>{{liveCounter._minutes}}</p><span class="description">Minutes</span></div><span class="font-28">:</span>
                               <div><p>{{liveCounter._seconds}}</p><span class="description">Seconds</span></div>
                              </div>
                            </div>
                          </div>
                    </div>
                    <div id="chart" class="revenu-burn-chart col-12 col-lg-8 ps-md-3 px-md-2">
                        <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
                            [xaxis]="chartOptions.xaxis" [dataLabels]="chartOptions.dataLabels"
                            [grid]="chartOptions.grid" [stroke]="chartOptions.stroke" [title]="chartOptions.title"
                            [markers]="chartOptions.markers" [yaxis]="chartOptions.yaxis" [fill]="chartOptions.fill"
                            *ngIf="chartData" [tooltip]="chartOptions.tooltip"></apx-chart>
                        <div *ngIf="!chartData" class="chart-placeholder">
                            <div><img class="w-100 h-100" src="./assets/images/burn_chart_alt.png" alt=""></div>
                            <div><img class="w-100 h-100" src="./assets/images/burn_chart_alt.png" alt=""></div>
                            <div><img class="w-100 h-100" src="./assets/images/burn_chart_alt.png" alt=""></div>
                        </div>
                    </div>
                </div>
            </div> -->


            <!--===== buy back and wsm supply ====-->
            <div class="col-12 mt-4 mb-md-0 mb-4">
                <div class="card py-2 px-3 flex-row justify-content-between">
                    <div class="col-md-7 col-12">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="title font-14 text-uppercase" translate>buy_back_supply</div>
                            <div class="popover__wrapper mb-0">
                                <h2 class="popover__title info-icon m-0">
                                    <svg-icon src="./assets/images/svg-icons/info.svg"
                                    [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"></svg-icon>
                                </h2>
                                <div class="popover__content text-start">
                                    <p class="popover__message mb-0" translate>buyback_tooltip</p>
                                </div>
                            </div>
                        </div>
                        <div class="bg-black card p-3 pb-2 mt-2">
                            <div class="d-flex align-items-center justify-content-between">
                                <img src="./assets/images/svg-icons/white-money.svg" alt="">
                                <div class="d-flex align-items-center progressHolder">
                                    <span class="line1" [style.width]="wsmValues?.totalWsmBurntPercentage + '%'"></span>
                                    <!-- <span class="line2 mx-1" [style.width]="wsmValues?.totalWsmRewardsInWalletPercentage + '%'"></span> -->
                                    <span class="line3 mx-1" [style.width]="wsmValues?.totalWsmStakedPercentage + '%'"></span>
                                    <span class="line4" [style.width]="wsmValues?.circulatingWsmSupplyPercentage + '%'"></span>
                                </div>
                            </div>
                            <p class="font-9 d-flex justify-content-end text-white m-0 p-0">
                                <span translate>original_wsm_supply</span>
                            </p>
                        </div>
                        <div class="d-sm-flex flex-column flex-md-row justify-content-between align-items-center pt-2 ps-2">
                            <div class="col-md-6 col-12">
                                <div class="my-2 mt-md-3 mb-md-5">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <!-- <span class="progress bg-success"></span> -->
                                        <p class="font-11 m-0 p-0 px-2 fw-bold" translate>total_wsm_supply</p>
                                        <!-- <span class=" fw-bold font-12 text-success">{{convertNum(wsmValues?.totalWsmRewardsInWalletPercentage)}}%</span> -->
                                    </div>
                                    <h2 class="title font-20 pt-2 d-flex justify-content-start">
                                        {{convertNum(2000000000,0)}} WSM
                                    </h2>
                                </div>
                                <div class="my-4">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <span class="progress"></span>
                                        <p class="font-11 m-0 p-0 px-2 fw-bold" translate>total_wsm_burnt</p>
                                        <span class="text-primary fw-bold font-12">{{convertNum(wsmValues?.totalWsmBurntPercentage)}}%</span>
                                    </div>
                                    <h2 class="title font-20 pt-2 d-flex justify-content-start">
                                        {{convertNum(wsmValues?.totalWsmBurnt,0)}} WSM
                                    </h2>
                                </div>
                                <!-- <div class="my-4">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <span class="progress bg-success"></span>
                                        <p class="font-11  m-0 p-0 px-2 fw-bold" translate>total_wsm_rewards</p>
                                        <span class=" fw-bold font-12 text-success">{{convertNum(wsmValues?.totalWsmRewardsInWalletPercentage)}}%</span>
                                    </div>
                                    <h2 class="title font-20 pt-2 d-flex justify-content-start">
                                        {{convertNum(wsmValues?.totalWsmRewardsInWallet,0)}} WSM
                                    </h2>
                                </div> -->
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="my-2 mt-md-3 mb-md-5">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <span class="progress bg-tertiary"></span>
                                        <p class="font-11 m-0 p-0 px-2 fw-bold" translate>total_wsm_staked</p>
                                        <span class=" fw-bold font-12 text-tertiary">{{convertNum(wsmValues?.totalWsmStakedPercentage)}}%</span>
                                    </div>
                                    <h2 class="title font-20 pt-2 d-flex justify-content-start">
                                        {{convertNum(wsmValues?.totalWsmStaked,0)}} WSM
                                    </h2>
                                </div>
                                <div class="my-4">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <span class="progress bg-info"></span>
                                        <p class="font-11 m-0 p-0 px-2 fw-bold" translate>circulating_wsm_supply</p>
                                        <span class="text-info fw-bold font-12">{{convertNum(wsmValues?.circulatingWsmSupplyPercentage)}}%</span>
                                    </div>
                                    <h2 class="title font-20 pt-2 d-flex justify-content-start">
                                        {{convertNum(wsmValues?.circulatingWsmSupply,0)}} WSM
                                    </h2>
                                </div>
                            </div>
                            <div>
                            </div>
                        </div>
                    </div>

                    <div class="col-4 d-none d-md-flex flex-md-column align-items-center vroom-car justify-content-center me-2">
                        <img src="./assets/images/svg-icons/character-card-header.svg" class="img-fluid" alt="">
                        <div class="character-card h-100 w-100">
                        </div>
                    </div>
                </div>
            </div>

            
            <!--===== wsm token table  ====-->
            <!-- <div class="col-12 col-lg-12 my-4">
                <table class="fixed_header" *ngIf="tableData">
                    <thead>
                        <tr>
                            <th translate>token</th>
                            <th translate>value</th>
                            <th translate>wsm_amount</th>
                            <th translate>date</th>
                            <th translate>time</th>
                            <th translate>destination_address</th>
                            <th><img src="./assets/images/svg-icons/link.svg" alt=""></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of transaction.data">
                            <td> <img src="./assets/images/svg-icons/wall-token.svg" alt="" height="20" /></td>
                            <td>{{convertNum(item.usdValue, 0)}}</td>
                            <td>{{convertNum(item.wsmAmount, 0)}}</td>
                            <td>{{item.dateOfTx | date: 'dd/MM'}}</td>
                            <td>{{item.dateOfTx | date: 'shortTime'}}</td>
                            <td>
                                <div class="d-flex align-items-center justify-content-center" (click)="copy()"
                                    ngxClipboard [cbContent]="item.destinationAddress">
                                    <span class="d-inline-block hide-overflow font-13"
                                        translate>{{item.destinationAddress | trimAddress}}</span>
                                    <svg-icon src="./assets/images/svg-icons/copy.svg"
                                        [svgStyle]="{ 'width.px':20, 'height.px':20 }"
                                        class="ps-2 cursor-pointer"></svg-icon>
                                </div>
                            </td>
                            <td>
                                <a href="https://etherscan.io/address/{{item.destinationAddress}}" target="_blank">
                                    <svg-icon src="./assets/images/svg-icons/money.svg"
                                        [svgStyle]="{ 'width.px':20, 'height.px':20 }"
                                        class="ps-2 cursor-pointer"></svg-icon>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <button class="loadMore" (click)="loadMore()" *ngIf="transaction?.data.length < transaction?.count" translate>load_more</button> -->
        </div>
    </div>
</section>
